export const ON_BOARDING_ITEM_IDS = [44, 81];
//Employee on board
export const EMP_LIFECYCLE_CAT_ID = 4;
